exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nh4[data-v-bf1681ae]{color:#00AE39;margin-bottom:1px\n}\nspan[data-v-bf1681ae]{font-size:15px\n}\n", "", {"version":3,"sources":["/Applications/MAMP/htdocs/freelas/click2giv_v2/click2giv/src/components/Profile.vue"],"names":[],"mappings":";AA6EA,oBACE,cACA,iBAAkB;CACnB;AAAA,sBAEC,cAAe;CAChB","file":"Profile.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nh4{\n  color: #00AE39;\n  margin-bottom: 1px;\n}\nspan{\n  font-size: 15px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf1681ae","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profile.vue
// module id = a6QI
// module chunks = 0